<template>
  <div style="padding-bottom: 6rem">
    <header>
      <h1>FAQ</h1>
    </header>
    <section class="suporte">
      <div>
        <div class="row">
          <div class="col-12 col-sm-12">
            <h1>PERGUNTAS FREQUENTES.</h1>
          </div>
          <hr class="divider" />

          <div class="collapse-main" model="selectedListasRestSoap" v-for="item in dados.lista" :key="item.pergunta.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-')" :value="item.pergunta.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-')"  >
            <CollapseMenu :descricao="item.resposta" :titulo="item.pergunta" :codigo="String(item.pergunta.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-'))"/>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import AccordionItem from "./AccordionItem.vue";
import CollapseMenu from '../../components/CollapseMenu.vue';

export default {
  props: {},
  components: { AccordionItem, CollapseMenu },
  data() {
    return {
      dados: {
        idFaq: String,
        lista: [],
      },
      idFaq: String,
    };
  },

  methods: {
    async consultarFaq(idFaq) {
      try {
        const response = await axios.get(
          `/massificados/corporativo/gerenciador-parceiros/rest/faq-portal/consultar/${idFaq}`
        );
        this.dados = response.data;
      } catch (error) {
        throw error;
      }
    },
  },

  created() {},

  mounted() {
    setTimeout(function() {
      $('body').removeClass('overflow');
    }, 100);
 
    this.idFaq = this.$route.params.idFaq;
    this.consultarFaq(this.idFaq);
  },
};
</script>

<style scoped>
.mb-4 {
    margin-bottom: 1.5rem !important;
}
.collapse-main {
  margin-bottom: -3%;
}

@import "/massificados/corporativo/gerenciador-parceiros-ui/portal-api/css/style.css";
@import "/massificados/corporativo/gerenciador-parceiros-ui/suporte-portal-api/css/style.css";
</style>
